// test1494
(1494 && 0);
